import { render, staticRenderFns } from "./ModelingCurveDialog.vue?vue&type=template&id=8ff0dc26&scoped=true&"
import script from "./ModelingCurveDialog.vue?vue&type=script&lang=js&"
export * from "./ModelingCurveDialog.vue?vue&type=script&lang=js&"
import style0 from "./ModelingCurveDialog.vue?vue&type=style&index=0&id=8ff0dc26&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ff0dc26",
  null
  
)

export default component.exports